/**
 * The round badge in the footer (#image-rotation) turns as the page scrolls.
 */
export function initFooterBadgeRotation() {
    const image = document.getElementById('image-rotation');
    if (!image) return;

    window.addEventListener('scroll', function () {
        image.style.transform = 'translate(-50%,-50%) rotate(' + window.pageYOffset / 8 + 'deg)';
    }, { passive: true });
}
